import type {
  IssueWithPermissionCheck,
  IssueWithChildren,
  RestrictedIssue,
  IssueWithInteractions,
} from '@momentum/types';
import { IssueRole } from '@momentum/types';

export function isRestrictedIssue(
  issue: IssueWithPermissionCheck | IssueWithChildren
): issue is RestrictedIssue {
  return !issue.hasPermission;
}

export function hasFullPermission(
  issue: IssueWithPermissionCheck | IssueWithChildren
): issue is IssueWithInteractions {
  return issue.hasPermission;
}

export type FullIssueWithChildren = IssueWithInteractions & {
  children?: IssueWithChildren[];
  descendantInteractionIds?: string[];
};

export function assertFullIssue(
  issue: IssueWithChildren
): asserts issue is FullIssueWithChildren {
  if (isRestrictedIssue(issue)) {
    throw new Error('Expected full issue but got restricted issue');
  }
}

export function canEditIssue(
  issue: IssueWithPermissionCheck | IssueWithChildren
): boolean {
  if (!hasFullPermission(issue)) {
    return false;
  }

  if (!('role' in issue)) {
    return false;
  }

  return issue.role === IssueRole.OWNER || issue.role === IssueRole.ASSIGNEE;
}
